import React from "react";
import { Tab } from "@headlessui/react";
import { classNames } from "../../../../../helpers/functions";
import MedicationSidebarList from "./MedicationSidebarList";
import { drugTypes } from "../../service-steps/clinical-assessment/data";

const PrescriptionSection = ({
  filteredMedication,
  showPrescriptionMeds,
  setShowPrescriptionMeds,
  onMedicationClick,
  onMenuAction,
  onExpandMedication,
  expandedMedications,
  hoveredMed,
  onMouseEnter,
  onMouseLeave,
  menuMedication,
  onMenuOpen,
  showMenu,
  menuData,
  selectedMedication,
  isMatchingDrug,
  medicationDetails,
  getNoRecordMessage,
  isIntervention,
}) => {
  return (
    <Tab.Group className="w-full h-full flex flex-col">
      <Tab.Panels className="w-full flex-1 flex flex-col">
        <Tab.Panel
          className={classNames(
            "rounded-xl bg-white w-full flex-1 flex flex-col",
            "ring-white ring-opacity-60 ring-offset-2 focus:outline-none focus:ring-2"
          )}
        >
          <MedicationSidebarList
            medications={filteredMedication?.filter(
              (x) => x.medicationType === drugTypes.Prescription
            )}
            title="Prescriptions"
            isExpanded={showPrescriptionMeds}
            onToggleExpanded={() => setShowPrescriptionMeds(!showPrescriptionMeds)}
            onMedicationClick={onMedicationClick}
            onMenuAction={onMenuAction}
            onExpandMedication={onExpandMedication}
            expandedMedications={expandedMedications}
            hoveredMed={hoveredMed}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            menuMedication={menuMedication}
            onMenuOpen={onMenuOpen}
            showMenu={showMenu}
            menuData={menuData}
            selectedMedication={selectedMedication}
            isMatchingDrug={isMatchingDrug}
            medicationDetails={medicationDetails}
            getNoRecordMessage={getNoRecordMessage}
            drugType={drugTypes.Prescription}
            isIntervention={isIntervention}
          />
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  );
};

export default PrescriptionSection;
